export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '3532493f-932d-4b3c-8480-3751204e6584';
export const MODAL_CLOSE_SEC = 2.5;
